// extracted by mini-css-extract-plugin
export default {"loader":"loader--ZULV3","svg":"svg--AHqEu","path":"path--S0YfG","dash":"dash--dgxK1"};